export default __webpack_public_path__ + "static/media/image-coming-soon.90bd9cdd.jpg";